<template>
	<div id="container" class="container">
		<myheader></myheader>
		<div class="mx1360">
			<div class="mbxbox between align-c">
				<!-- <div style="flex: 1;" class="blank-flex"></div> -->
				<div class="mbx">
					您当前的位置：<a href="/" class="cur curadm">首页</a> >> <span class="fc66">新闻动态</span>
				</div>
				<div class="searchBox">
					<el-input clearable size="small" placeholder="请输入搜索关键字" v-model="keywords"
						class="input-with-select">
						<el-button slot="append" icon="el-icon-search" @click="search()"></el-button>
					</el-input>
				</div>
			</div>

		</div>
		<div class="mx1360 doclist">
			<div class="pd">
				<div style="display: flex;justify-content: center;" v-if="list.length == 0">
					<el-empty description="暂无数据"></el-empty>
				</div>
				<ul>
					<li class="cur" v-for="v, k in list" :key="k" @click="tourl_blank(v)">
						<div class="tit">
							<div class="t1 hideLine1">{{ v.title || '' }}</div>
							<div class="t2 hideLine2">
								{{ v.description || '' }}
							</div>
						</div>
						<div class="time">{{ v.create_time || '' }}</div>
					</li>
				</ul>
			</div>

			<div class="vcenter pagination">
				<el-pagination background layout="prev, pager, next" :total="total" @prev-click="prevClick"
					@next-click="nextClick" @size-change="sizeChange" @current-change="currentChange">
				</el-pagination>
			</div>

		</div>

		<myfooter></myfooter>
	</div>
</template>

<script>
import util from "@/common/util.js";
import ty from "@/utils/ty/ty";

export default {
	data() {
		return {
			keywords: '',
			total: 0,
			list: [],
			//          info:{},
			// lm:""
		}
	},
	mounted() {

		this.getList()
	},
	methods: {
		getList() {
			let that = this;
			ty.ajax('web/web/list', { k: this.keywords }).then((result) => {
				that.list = result.data.data;
				that.total = result.data.meta.totalCount;
			});

		},
		tourl_blank(v) {
			util.tourl_blank("/detail", { id: v.id, lm: "新闻动态" })
		},
		prevClick(e) {
			console.log(e)
		},
		nextClick(e) {
			console.log(e)
		},
		sizeChange(e) {
			console.log(e)
		},
		currentChange(e) {
			console.log(e)
		},
		search() {
			console.log("搜索")
			this.getList()
		},

	}
}
</script>

<style lang="scss">
@import '../style.scss'; //所有页面公用
@import "./doclist.scss";
</style>